'use strict';

/**
 * @ngdoc function
 * @name gfcmsApp.controller:IndexCtrl
 * @description
 * # IndexCtrl
 * Controller of the gfcmsApp
 */
angular.module('gfcmsApp')
  .controller('IndexCtrl',
    function($location, $rootScope, $document, AuthenticationService, eventsService,
      cfpLoadingBar, $window, errorlogService) {

      var index = this;

      var w = window.jQuery($window);
      index.loggedIn = $rootScope.loggedIn;
      index.format = 'hh:mm a';

      $rootScope.$on(eventsService.loggedInEvent, function() {
        index.loggedIn = true;
      });

      $rootScope.$on(eventsService.loggedOutEvent, function() {
        index.loggedIn = false;
      });

      w.bind('resize', function() {
        activate();
      });

      activate();
      // niceScroll();

      function activate() {
        var wSize = w.width();
        if (wSize <= 768) {
          $(document).find('#container').addClass('sidebar-close');
          $(document).find('#sidebar > ul').hide();
        }

        if (wSize > 768) {
          $(document).find('#container').removeClass('sidebar-close');
          $(document).find('#sidebar > ul').show()
        }
      }

      function logout() {
        var ev = eventsService.loggedOutStart();
        if (!ev.defaultPrevented) {
          $location.path('/login');
          AuthenticationService.Logout();
          eventsService.loggedOut();
          index.loggedIn = false;
        }
      }

      function toggleMenu() {
        if ($document.find('#sidebar > ul').is(':visible') === true) {
          $document.find('#main-content').css({
            'margin-left': '0px'
          });
          $document.find('#sidebar').css({
            'margin-left': '-210px'
          });
          $document.find('#sidebar > ul').hide();
          $document.find('#container').addClass('sidebar-closed');
        } else {
          $document.find('#main-content').css({
            'margin-left': '210px'
          });
          $document.find('#sidebar > ul').show();
          $document.find('#sidebar').css({
            'margin-left': '0'
          });
          $document.find('#container').removeClass('sidebar-closed');
        }
      }

      function niceScroll() {
        // $document.find('#sidebar').niceScroll({
        //   styler: 'fb',
        //   cursorcolor: '#4ECDC4',
        //   cursorwidth: '3',
        //   cursorborderradius: '10px',
        //   background: '#404040',
        //   spacebarenabled: false,
        //   cursorborder: ''
        // });
        $document.find('html').niceScroll({
          styler: 'fb',
          cursorcolor: '#4ECDC4',
          cursorwidth: '6',
          cursorborderradius: '10px',
          background: '#404040',
          spacebarenabled: false,
          cursorborder: '',
          zindex: '1000'
        });
      }

      index.logout = logout;
      index.toggleMenu = toggleMenu;
    });
